import React from 'react';

import { batch } from 'react-redux';

import { PreQualificationStep, setPreQualificationStep } from 'prequalificationV2/actions';
import { clearCoBorrower } from 'prequalificationV2/actions/coBorrower';
import { clearIncome } from 'prequalificationV2/actions/income';
import { clearPrequalificationPortal } from 'prequalificationV2/actions/prequalificationPortal';
import { Button } from 'components/Buttons/Button';
import FormHeader from 'components/FormHeader';
import { ButtonType } from 'enums/ButtonType';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { Theme } from 'enums/Theme';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import useAppNavigate from 'hooks/useAppNavigate';
import { AppRoutes } from 'prequalificationV2/routes/routes.enums';

import styles from './NoActiveApplication.module.scss';

const FORM_HEADER_TITLE = 'Welcome back to your HFS Loan Portal';
const FORM_HEADER_SUBTITLE = 'Your prior application is no longer active. Please, submit a new application below.';

const NoActiveApplication = () => {
  const dispatch = useAppDispatch();
  const navigator = useAppNavigate();
  const handleStartNewApplicationClick = () => {
    batch(() => {
      dispatch(clearPrequalificationPortal());
      dispatch(clearCoBorrower());
      dispatch(clearIncome());

      dispatch(setPreQualificationStep(PreQualificationStep.BorrowerIdentity));
      navigator(AppRoutes.Prequalification);
    });
  };

  return (
    <div>
      <FormHeader
        title={FORM_HEADER_TITLE}
        subtitle={FORM_HEADER_SUBTITLE}
        theme={Theme.Dark}
        isBorderRounded
        percent={ProgressBarStatus.Failed}
      />
      <Button
        buttonType={ButtonType.Primary}
        onClick={handleStartNewApplicationClick}
        className={styles.startNewApplicationButton}
      >
        Start New Application
      </Button>
    </div>
  );
};

export default NoActiveApplication;
